module.exports = __webpack_public_path__ + "img/stripe_visa_light.5bfbdf6c.png";